<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="dialog-icon" fontIcon="system_update_alt"></mat-icon>
  <span>{{ 'platform.version-update.title' | translate }}</span>
</h2>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-message">
    {{ 'platform.version-update.description' | translate: { version: data?.version } }}
  </p>
</div>

<div mat-dialog-actions align="center" class="dialog-actions">
  <button mat-raised-button class="update-button btn btn-sm btn-primary" (click)="reload()">
    <div class="button-content text-white">
      <span class="button-title">{{ 'platform.version-update.action-title' | translate }}</span>
      <span class="button-subtitle">{{ 'platform.version-update.action-subtitle' | translate }}</span>
    </div>
  </button>
</div>
